export const testInfo = {
    "question_number": "Số câu hỏi",
    "question_number_learning": "Số nội dung cần hoàn thành",
    "number_of": "Số lần",
    "welcome_final_test": "Bài kiểm tra",
    "max_try_time": "Số lần làm bài tối đa",
    "number_try_time": "Số lần đã thực hiện",
    "unlimited": "Không giới hạn số lần làm",
    "SUBMITTING": "Đang hoàn thành",
};
